export default {
  next: '下一步',
  resetPassword: '重置密码',
  sendEmailRegisteredCode: '我们将发送验证码至您所注册的邮箱地址。',
  sendPhoneRegisteredCode: '我们将发送验证码到您的手机上。',
  labelRegisteredEmail: '请输入您的注册邮箱地址',
  labelRegisteredPhone: '请输入您的手机号码',
  enterEmail: '输入您的邮箱',
  validEmail: '请输入正确的邮箱',
  enterMobilePhone: '输入您的手机号码',
  validPhone: '请输入正确的手机号',
  verificationCode: '请输入验证码',
  enterNewPassword: '请输入新的密码',
  reEnterNewPassowrd: '请再次输入新的密码',
  ruleEmail: '请输入您的邮箱地址',
  ruleMobilePhone: '请输入您的手机号码',
  labelCode: '请输入验证码',
  noMatchPassword: '密码不一致，请重新输入',
  showPasswordRules: '密码至少为8位字符，并同时包含字母和数字',
}
